import { lazy, Suspense } from "react";

const Gallery = lazy(() => import("./Gallery").then((m) => ({ default: m.Gallery })));
const ContactForm = lazy(() =>
  import("./ContactForm").then((m) => ({ default: m.ContactForm })),
);

export function LazyGallery() {
  return (
    <Suspense
      fallback={
        <section
          id="gallery"
          aria-label="Gallery"
          className="surface-cream grain hairline min-h-[24rem] py-24 sm:py-32"
        />
      }
    >
      <Gallery />
    </Suspense>
  );
}

export function LazyContactForm() {
  return (
    <Suspense fallback={<div className="min-h-[22rem]" aria-hidden="true" />}>
      <ContactForm />
    </Suspense>
  );
}
